import Page from 'attendee/theme/Page'
import React from 'react'
import {Helmet} from 'react-helmet'
import {DEFAULT_OG_IMAGE, SITE_ORIGIN} from 'seo/siteMeta'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'
import {withLocalePath} from 'i18n/localePaths'
import {routes} from 'routes/routes'

export function ApiDocs() {
  const {t, locale} = useI18n()
  const pageUrl = `${SITE_ORIGIN}${withLocalePath(locale, routes.apiDocs)}`
  return (
    <Page>
      <>
        <Helmet>
          <title>{t('apiDocs.metaTitle')}</title>
          <meta name="description" content={t('apiDocs.metaDescription')} />
          <link rel="canonical" href={pageUrl} />
          <meta property="og:title" content={t('apiDocs.ogTitle')} />
          <meta
            property="og:description"
            content={t('apiDocs.ogDescription')}
          />
          <meta property="og:url" content={pageUrl} />
          <meta property="og:image" content={DEFAULT_OG_IMAGE} />
          <meta property="og:image:secure_url" content={DEFAULT_OG_IMAGE} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </Helmet>

        <section className="contact_section dark_light_class pt-55 pb-55">
          <div className="container">
            <div className="section__title-wrapper mb-80">
              <span className="section__back-title">API</span>
              <span className="section__subtitle">
                {t('apiDocs.heroSubtitle')}
              </span>
              <h1 className="section__title">
                Eventa.tv <span className="text__highlight">API</span>
              </h1>
            </div>

            <div className="row">
              <div className="col-12">
                <p>{t('apiDocs.updated')}</p>

                <StyledH3>{t('apiDocs.introTitle')}</StyledH3>
                <p>{t('apiDocs.introP')}</p>

                <StyledH3>{t('apiDocs.baseUrl')}</StyledH3>
                <CodeBlock>{`https://eventa.tv/api`}</CodeBlock>

                <StyledH3>{t('apiDocs.authTitle')}</StyledH3>
                <p>{t('apiDocs.authP')}</p>
                <CodeBlock>{`{
  "api_token": "YOUR_TOKEN_HERE"
}`}</CodeBlock>

                <Divider />
                <StyledH3>{t('apiDocs.linkTitle')}</StyledH3>
                <p>{t('apiDocs.linkP')}</p>

                <StyledH3>{t('apiDocs.bodyParams')}</StyledH3>
                <StyledUl>
                  <li>{t('apiDocs.linkTokenLi')}</li>
                </StyledUl>

                <StyledH3>{t('apiDocs.exampleRequest')}</StyledH3>
                <CodeBlock>{`POST https://eventa.tv/api/zapier/link
Content-Type: application/json
{
  "api_token": "YOUR_TOKEN_HERE"
}`}</CodeBlock>

                <StyledH3>{t('apiDocs.successResp')}</StyledH3>
                <CodeBlock>{`{
  "status": "success",
  "message": "MyEvent (your@email.com)"
}`}</CodeBlock>

                <StyledH3>{t('apiDocs.errorResp')}</StyledH3>
                <CodeBlock>{`{
  "status": "error",
  "message": "Invalid API token."
}`}</CodeBlock>

                <Divider />
                <StyledH3>{t('apiDocs.createTitle')}</StyledH3>
                <p>{t('apiDocs.createP')}</p>

                <StyledH3>{t('apiDocs.bodyParams')}</StyledH3>
                <StyledUl>
                  <li>{t('apiDocs.createTokenLi')}</li>
                  <li>{t('apiDocs.createEmailLi')}</li>
                  <li>{t('apiDocs.createResLi')}</li>
                </StyledUl>

                <StyledH3>{t('apiDocs.exampleRequest')}</StyledH3>
                <CodeBlock>{`PUT https://eventa.tv/api/zapier/create
Content-Type: application/json
{
  "api_token": "YOUR_TOKEN_HERE",
  "email": "user@example.com",
  "reservation": true
}`}</CodeBlock>

                <StyledH3>{t('apiDocs.successResp')}</StyledH3>
                <CodeBlock>{`{
  "status": "success",
}`}</CodeBlock>

                <StyledH3>{t('apiDocs.errorResp')}</StyledH3>
                <CodeBlock>{`{
  "status": "error",
  "message": "Email is invalid."
}`}</CodeBlock>

                <Divider />
                <StyledH3>{t('apiDocs.removeTitle')}</StyledH3>
                <p>{t('apiDocs.removeP')}</p>

                <StyledH3>{t('apiDocs.bodyParams')}</StyledH3>
                <StyledUl>
                  <li>{t('apiDocs.removeTokenLi')}</li>
                  <li>{t('apiDocs.removeEmailLi')}</li>
                </StyledUl>

                <StyledH3>{t('apiDocs.exampleRequest')}</StyledH3>
                <CodeBlock>{`DELETE https://eventa.tv/api/zapier/remove
Content-Type: application/json
{
  "api_token": "YOUR_TOKEN_HERE",
  "email": "user@example.com"
}`}</CodeBlock>

                <StyledH3>{t('apiDocs.successResp')}</StyledH3>
                <CodeBlock>{`{
  "status": "success",
}`}</CodeBlock>

                <StyledH3>{t('apiDocs.errorResp')}</StyledH3>
                <CodeBlock>{`{
  "status": "error",
  "message": "User not found."
}`}</CodeBlock>
              </div>
            </div>
          </div>
        </section>
      </>
    </Page>
  )
}

const StyledH3 = styled.h3`
  margin-top: 1.5rem;
  font-size: 26px;
  font-weight: 700;
`

const StyledUl = styled.ul`
  padding-left: 1.25rem;
  color: var(--bs-body-color);
  li {
    margin-bottom: 6px;
  }
`

const CodeBlock = styled.pre`
  background: #ebebeb;
  padding: 18px 22px;
  border-radius: 12px;
  margin-top: 15px;
  overflow-x: auto;
`

const Divider = styled.div`
  height: 2px;
  background: rgba(255, 255, 255, 0.05);
  margin: 40px 0;
`
